import { render, staticRenderFns } from "./DashboardWelcome.vue?vue&type=template&id=127381bf&scoped=true"
import script from "./DashboardWelcome.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardWelcome.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DashboardWelcome.vue?vue&type=style&index=0&id=127381bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127381bf",
  null
  
)

export default component.exports